<template>
  <div>
    <!-- pc端 -->
    <div class="root_layout" v-if="showDev">
      <!-- title -->
      <div class="title">
        <label class="title_text">爱尔眼科旗下高端近视矫正手术品牌</label>
        <div>
          <!-- <label class="title_text">联系电话：17727907108</label> -->
          <label class="title_text" style="margin-left: 20px"
            >营业时间 10:00-19:00</label
          >
        </div>
      </div>
      <div
        class="flex_column transition_all fixed z_index_10 width_100 overflow_hidden"
        :class="{
          margin_top_30: isShowTitle
        }"
      >
        <!-- tab -->
        <div class="tab_layout">
          <img src="../assets/images/logo.png" />
          <div class="tab_div">
            <div
              class="tab"
              :class="{ tab_selected: active == 1 }"
              @mouseenter="tabMouseMove(1)"
              @mouseleave="tabMouseLeave()"
              @click="tabClick(0)"
              ref="tab1"
            >
              首页
            </div>
            <div
              class="tab"
              :class="{ tab_selected: active == 2 }"
              @mouseenter="tabMouseMove(2)"
              @mouseleave="tabMouseLeave()"
              @click="tabClick(1)"
              ref="tab2"
            >
              关于西柚
            </div>
            <div
              class="tab"
              :class="{ tab_selected: active == 3 }"
              @mouseenter="tabMouseMove(3)"
              @mouseleave="tabMouseLeave()"
              @click="tabClick(2)"
              ref="tab3"
            >
              医生团队
            </div>
            <div
              class="tab"
              :class="{ tab_selected: active == 4 }"
              @mouseenter="tabMouseMove(4)"
              @mouseleave="tabMouseLeave()"
              @click="tabClick(3)"
              ref="tab4"
            >
              矫正流程
            </div>
            <div
              class="tab"
              :class="{ tab_selected: active == 5 }"
              @mouseenter="tabMouseMove(5)"
              @mouseleave="tabMouseLeave()"
              @click="tabClick(4)"
              ref="tab5"
            >
              术式介绍
            </div>
            <div
              class="tab"
              :class="{ tab_selected: active == 6 }"
              @mouseenter="tabMouseMove(6)"
              @mouseleave="tabMouseLeave()"
              @click="tabClick(5)"
              ref="tab6"
            >
              常见问题
            </div>
          </div>
          <div
            class="tab_selected_bg"
            :style="{ left: left + 'px', width: tabSelectedWidth + 'px' }"
          ></div>
        </div>
      </div>

      <!-- 首页 -->
      <div v-if="selectedTab == 0" class="flex_column margin_top_64">
        <!-- banner -->
        <div
          v-if="banner"
          class="banner_layout"
          @mouseenter="bannerMouseMove()"
          @mouseleave="bannerMouseLeave()"
          @click="go_banner(banner[seletcedBanner])"
        >
          <div style="display: flex">
            <img
              :src="
                banner[
                  seletcedBanner == 0 ? banner.length - 1 : seletcedBanner - 1
                ].img
              "
              class="banner_img"
              :style="getBanner1Style()"
            />
            <!-- <div :style="getBanner1Style()" class="banner_img_mask"></div> -->
          </div>
          <img
            :src="banner[seletcedBanner].img"
            class="banner_img"
            style="position: absolute"
            :style="getBanner2Style()"
          />
          <div class="banner_indicator_layout">
            <div
              v-for="(item, index) in banner"
              class="banner_indicator"
              :class="{ banner_indicator_selected: seletcedBanner == index }"
            ></div>
          </div>
          <div class="banner_btn_layout">
            <div
              class="banner_btn"
              :class="{
                banner_btn_left: isShowBannerBtn,
                banner_btn_left_out: !isShowBannerBtn
              }"
              @click.stop="switchBanner(1)"
            >
              <img src="../assets/images/banner_left.png" />
            </div>
            <div
              class="banner_btn"
              :class="{
                banner_btn_right: isShowBannerBtn,
                banner_btn_right_out: !isShowBannerBtn
              }"
              @click.stop="switchBanner(2)"
            >
              <img src="../assets/images/banner_right.png" />
            </div>
          </div>
        </div>

        <!-- hospital -->
        <div class="hospital_profile_layout">
          <div style="display: flex; flex-direction: column">
            <div
              class="hospital_profile_tab"
              :class="{ hospital_profile_tab_animation: item.isSelected }"
              v-for="(item, index) in hospiatlProfiles"
              @mouseenter="profileClick(index)"
              @mouseleave="profileLeave()"
            >
              <div class="hospital_profile_tab_title">
                <div class="hospital_profile_text">{{ item.title }}</div>
                <img
                  class="hospiatl_profile_img"
                  :class="{ hospiatl_profile_img_selected: item.isSelected }"
                  :src="
                    item.isSelected
                      ? require('../assets/images/ic_down.png')
                      : require('../assets/images/ic_right.png')
                  "
                />
              </div>
              <div
                class="hospital_profile_tab_content"
                :class="{
                  hospital_profile_tab_content_selected: item.isSelected
                }"
              >
                {{ item.content }}
              </div>
            </div>
          </div>
          <div class="hospital_profile_img_layout">
            <img
              class="hospital_profile_img"
              :class="{ hospital_profile_img_fade_out: isSwithingProfileImg }"
              :src="hospiatlProfiles[lastSelectedProfile].img"
            />
            <img
              class="hospital_profile_img"
              :class="{ hospital_profile_img_fade_in: isSwithingProfileImg }"
              :src="hospiatlProfiles[selectedProfile].img"
            />
          </div>
        </div>

        <!-- doctor -->
        <div class="doctor_layout">
          <div class="doctor_img_bg">
            <img
              :src="doctors[lastSelectDoctor].img"
              class="doctor_img"
              :class="{ hospital_profile_img_fade_out: isSwithingDoctor }"
              style="opacity: 0"
            />
            <div style="position: absolute; overflow: hidden; height: 480px">
              <img
                :src="doctors[selectedDoctor].img"
                class="doctor_img"
                :class="{ hospital_profile_img_fade_in: isSwithingDoctor }"
              />
            </div>
          </div>
          <div class="doctor_info_layout">
            <div
              class="doctor_text_layout"
              style="opacity: 0"
              :class="{ hospital_profile_img_fade_out: isSwithingDoctor }"
            >
              <div class="doctor_name_layout">
                <div class="doctor_name">
                  {{ doctors[lastSelectDoctor].name }}
                </div>
                <div class="doctor_position">
                  {{ doctors[lastSelectDoctor].position }}
                </div>
              </div>
              <div class="doctor_line"></div>
              <div class="doctor_honer">
                {{ doctors[lastSelectDoctor].positionInfo }}
              </div>
              <div class="doctor_info">
                <div class="doctor_info_item">
                  {{ doctors[lastSelectDoctor].intro }}
                </div>
              </div>
            </div>
            <div
              class="doctor_text_layout"
              style="position: absolute"
              :class="{ hospital_profile_img_fade_in: isSwithingDoctor }"
            >
              <div class="doctor_name_layout">
                <div class="doctor_name">
                  {{ doctors[selectedDoctor].name }}
                </div>
                <div class="doctor_position">
                  {{ doctors[selectedDoctor].position }}
                </div>
              </div>
              <div class="doctor_line"></div>
              <div class="doctor_honer">
                {{ doctors[selectedDoctor].positionInfo }}
              </div>
              <div class="doctor_info">
                <div class="doctor_info_item">
                  {{ doctors[selectedDoctor].intro }}
                </div>
              </div>
            </div>
            <div class="doctor_list">
              <div
                class="doctor_list_item"
                v-for="(item, index) in doctors"
                @click="switchDoctor(index)"

                :class="{ doctor_list_item_selected: index == selectedDoctor }"
              >
              <!-- @mouseleave="switchFirstDoctor()" -->
                <img
                  :src="doctors[index].headIcon"
                  class="doctor_list_item_img"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- step -->
        <div style="display: flex; flex-direction: column">
          <div class="doctor_step_layout">
            <div
              class="doctor_step"
              v-for="(item, index) in steps"
              :class="{ doctor_step_margin: index > 0 }"
              @mouseenter="stepMouseMove(index)"
              @mouseleave="stepMouseLeave()"
            >
              <div style="display: flex">
                <img
                  v-if="item.title != '小程序在线挂号'"
                  :src="item.img"
                  class="doctor_step_img"
                  :ref="'step_image' + index"
                />
                <img
                  style="margin-top: 0; height: 111px"
                  v-if="item.title == '小程序在线挂号'"
                  src="@/assets/images/dzt.jpg"
                  class="doctor_step_img"
                  :ref="'step_image' + index"
                />
                <!-- <img
                  style="margin-top: 0; height: 111px"
                  v-if="item.title == '医生定制专属方案'"
                  src="@/assets/images/xcxt.jpg"
                  class="doctor_step_img"
                  :ref="'step_image' + index"
                /> -->
                <div
                  class="doctor_step_img_mask"
                  style="position: absolute"
                  :class="{ doctor_step_img_mask_fade_out: item.isSelected }"
                ></div>
              </div>
              <img
                :src="item.isSelected ? item.selectedIcon : item.icon"
                class="doctor_step_icon"
              />

              <div
                class="doctor_step_text"
                :class="{ doctor_step_text_selected: item.isSelected }"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
          <div class="doctor_step_line"></div>
          <div
            class="doctor_step_line_selected"
            ref="line"
            :style="{ left: stepLeft + 'px' }"
          ></div>
        </div>

        <!-- bottom -->
        <div class="bottom_layout">
          <div class="bottom_text">
            联系地址：深圳市南山区高新南一道6号TCL大厦A座210<br /><br />

            交通线路：<br />
            地铁1号线至高新园B出口，在十字路口右转直行20米左右，上楼梯前行100米左右即可到达门诊正门。<br /><br />

            乘坐235路、323路、324路等公交路线在“大冲①”下车，往前经过十字路口后向左直行20米左右，上楼梯前行100米左右即可到达门诊正门。<br /><br />

            乘坐72路、235路、M530路等公交路线在“高新园地铁站”下，往万象天地方向直行20米左右，向后上楼梯前行100米左右即可到达门诊正门。
          </div>
          <div class="botton_qr_code_layout">
            <img
              style="width: 130px; height: 130px"
              src="../assets/images/xhs.png"
            />
            <div class="botton_qr_code_text">官方小红书</div>
          </div>
          <div class="botton_qr_code_layout">
            <img
              style="width: 130px; height: 130px"
              src="../assets/images/qr_code.png"
            />
            <div class="botton_qr_code_text">扫码添加客服预约</div>
          </div>
        </div>

        <!-- title -->
        <div class="title">
          <label class="title_text"
            >ICP备案：<a href="https://beian.miit.gov.cn/"
              >粤ICP备2021179031号-1</a
            ></label
          >
          <div>
            <!-- <label class="title_text">联系电话：17727907108</label> -->
            <label class="title_text" style="margin-left: 20px"
              >营业时间 10:00-19:00</label
            >
          </div>
        </div>
        <div class="float_layout">
          <div
            class="float_item"
            :class="{ float_item_open: switchingFloat == index }"
            :style="{
              width: switchingFloat == index ? floatWidth + 'px' : '60px',
              height: switchingFloat == index ? floatHeight + 'px' : '60px'
            }"
            v-for="(item, index) in floats"
            @mouseenter="floatMouseMove(index)"
            @mouseleave="floatMouseLeave()"
          >
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
                cursor: pointer;
              "
              @click="go_webview(item)"
            >
              <img
                class="float_item_img"
                :src="
                  switchingFloat == index
                    ? item.showImg
                    : selectedFloat == index
                    ? item.selectedImg
                    : item.img
                "
              />
              <div
                class="float_item_text"
                v-show="switchingFloat == index"
                :class="{ float_item_text_in: switchingFloat == index }"
              >
                {{ item.text }}
              </div>
            </div>
            <img
              style="margin-top: 11px"
              :src="item.image"
              v-show="switchingFloat == index && item.image"
              :class="{ float_item_img_in: switchingFloat == index }"
            />
          </div>
        </div>
      </div>
      <!-- 首页结束-->

      <!-- 关于西柚 -->
      <div
        v-if="selectedTab == 1"
        class="flex_column justify_center align_center margin_top_64"
      >
        <div class="flex_column justify_center align_center width_100">
          <Video
            v-if="about.topImg.indexOf('mp4') > -1"
            :src="about.topImg"
            :second="3"
            :width="'100%'"
            :height="900"
          />
          <img
            v-if="about.topImg.indexOf('mp4') == -1"
            class="about_top_img"
            :src="about.topImg"
          />
          <div
            v-if="isShowAboutTitle"
            class="flex_column position_absolute align_center"
            :class="startAnimation ? 'about_top_in' : 'about_top_out'"
          >
            <p class="about_top_title" v-html="about.title"></p>
            <p class="about_top_text">{{ about.title2 }}</p>
          </div>
          <div class="about_top_bg width_100 position_absolute"></div>
        </div>

        <div class="about_info_div" style="margin-top: 78px">
          <div class="about_info_title">{{ about.title3 }}</div>
          <p class="about_info_content">
            {{ about.content }}
          </p>
        </div>

        <!-- 发展历程 -->
        <div
          class="flex_column about_history_div width_100 align_center"
          style="margin-top: 53px"
        >
          <div class="flex_row width_100 about_history_title_div">
            <p class="about_history_title">发展历程</p>
            <div class="flex_row about_history_tab_div">
              <div
                :class="
                  aboutHistoryTab == 0 ? 'about_tab_selected' : 'about_tab'
                "
                @click="switchAboutHistory(0)"
              >
                {{ about.historyTitle }}
              </div>
              <div
                :class="
                  aboutHistoryTab == 1 ? 'about_tab_selected' : 'about_tab'
                "
                style="margin-left: 43px"
                @click="switchAboutHistory(1)"
              >
                {{ about.historyTitle2 }}
              </div>
            </div>
          </div>

          <!-- 发展历程1 -->
          <div
            class="line width_100"
            :style="aboutHistoryTab == 0 ? { opacity: 1 } : { opacity: 0 }"
          ></div>
          <div
            :style="aboutHistoryTab == 0 ? { opacity: 1 } : { opacity: 0 }"
            class="flex_row align_center"
            style="margin-top: 49px"
          >
            <div class="flex_row" style="flex: 1">
              <div class="flex_column justify_center align_center">
                <img
                  src="../assets/images/ic_about_history_up.png"
                  style="width: 24px; height: 13px"
                  @click="aboutHistoryYear(selectedYear - 1)"
                />
                <div class="about_year_div flex_column">
                  <div
                    v-for="(item, index) in years"
                    :key="index"
                    :ref="`year${index}`"
                    class="about_history_year"
                    @click="aboutHistoryYear(index)"
                    :class="{
                      about_history_year_select: index == selectedYear
                    }"
                    :style="{ top: yearTop + 'px' }"
                  >
                    {{ item.year }}
                  </div>
                </div>
                <img
                  src="../assets/images/ic_about_history_down.png"
                  style="width: 24px; height: 13px; margin-top: 32px"
                  @click="aboutHistoryYear(selectedYear + 1)"
                />
              </div>
              <div
                class="about_year_info"
                v-html="years[selectedYear].content"
                :class="{
                  hospital_profile_img_fade_in: startYearInfoAnimation
                }"
              ></div>
              <div
                class="about_year_info"
                v-html="
                  years[
                    selectedYear - 1 == -1 ? years.length - 1 : selectedYear - 1
                  ].content
                "
                :class="{
                  hospital_profile_img_fade_out: startYearInfoAnimation
                }"
                style="position: absolute; margin-left: 130px; opacity: 0"
              ></div>
            </div>
            <div class="flex_row" style="flex: 1; margin-left: 30px">
              <img
                :src="years[selectedYear].img"
                :class="{
                  hospital_profile_img_fade_in: startYearInfoAnimation
                }"
              />
              <img
                :src="years[lastSelectedYear].img"
                style="position: absolute; opacity: 0"
                :class="{
                  hospital_profile_img_fade_out: startYearInfoAnimation
                }"
              />
            </div>
          </div>

          <!-- 发展历程2 -->
          <div
            v-if="aboutHistoryTab == 1"
            class="flex_column width_100 align_center position_absolute"
            style="margin-top: 50px"
            :style="aboutHistoryTab == 1 ? { opacity: 1 } : { opacity: 0 }"
          >
            <div
              class="flex_row align_center"
              style="width: 1180px; margin-top: 35px"
            >
              <div class="about_year2_point about_year2_point_selected"></div>
              <div class="about_year2_line" style="flex: 1"></div>
              <div class="about_year2_point"></div>
              <div class="about_year2_line" style="flex: 1"></div>
              <div class="about_year2_point"></div>
              <div class="about_year2_line" style="flex: 1"></div>
            </div>
            <div class="flex_row overflow_hidden" style="margin-top: 100px">
              <div
                v-for="(item, index) in years2"
                :key="index"
                class="about_year2_info"
                :style="{ left: year2Left + 'px' }"
                @click="clickYear2(index)"
              >
                <label
                  class="about_year2_title"
                  :class="{
                    about_year2_text_unselected:
                      index < selectedYear2 || index > selectedYear2 + 2
                  }"
                  >{{ item.year }}</label
                >
                <p
                  class="about_year2_text"
                  :class="{
                    about_year2_text_unselected:
                      index < selectedYear2 || index > selectedYear2 + 2
                  }"
                >
                  {{ item.content }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- 星级诊疗 -->
        <div class="flex_row about_history_title_div" style="margin-top: 62px">
          <img :src="about.img4" style="flex: 1" />
          <div class="flex_column about_info_div">
            <label class="about_info_title">{{ about.title4 }}</label>
            <p class="about_info_text">
              {{ about.content4 }}
            </p>
          </div>
        </div>

        <!-- 百流手术室 -->
        <div class="flex_column about_history_div about_history_title_div">
          <label class="about_info_title">{{ about.title5 }}</label>
          <p class="about_info_text" style="margin-top: 27px">
            {{ about.content5 }}
          </p>
          <img style="margin-top: 20px" :src="about.img5" />
        </div>

        <!-- 高端智能设备 -->
        <div
          class="flex_column width_100 align_center"
          style="margin-top: 45px; margin-bottom: 50px"
        >
          <div class="flex_row width_100 about_history_title_div">
            <p class="about_history_title">高端智能化设备</p>
            <div class="flex_row about_history_tab_div">
              <div
                :class="
                  aboutEquipmentTab == 0 ? 'about_tab_selected' : 'about_tab'
                "
                @click="switchAboutEquipment(0)"
              >
                {{ about.equipmentTitle }}
              </div>
              <div
                :class="
                  aboutEquipmentTab == 1 ? 'about_tab_selected' : 'about_tab'
                "
                style="margin-left: 43px"
                @click="switchAboutEquipment(1)"
              >
                {{ about.equipmentTitle2 }}
              </div>
            </div>
          </div>
          <div
            class="flex_row width_100 about_history_title_div"
            style="margin-top: 27px"
          >
            <div
              class="flex_row"
              :style="aboutEquipmentTab == 0 ? { opacity: 1 } : { opacity: 0 }"
            >
              <div
                v-for="(item, index) in equipments1"
                :key="index"
                class="flex_column align_center"
                :style="{ 'margin-left': index > 0 ? '20px' : '0px' }"
              >
                <div
                  class="about_equipment flex_row align_center justify_center"
                >
                  <img class="image_s" :src="item.img" />
                </div>
                <label class="about_equipment_name">{{ item.name }}</label>
              </div>
            </div>
            <div
              class="flex_row position_absolute"
              :style="aboutEquipmentTab == 1 ? { opacity: 1 } : { opacity: 0 }"
            >
              <div
                v-for="(item, index) in equipments2"
                :key="index"
                class="flex_column align_center"
                :style="{ 'margin-left': index > 0 ? '20px' : '0px' }"
              >
                <div
                  class="about_equipment flex_row align_center justify_center"
                >
                  <img class="image_s" :src="item.img" />
                </div>
                <label class="about_equipment_name">{{ item.name }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 关于西柚 -->

      <!-- 医生团队 -->
      <div
        v-if="selectedTab == 2"
        class="flex_column justify_center align_center"
        style="margin-top: 108px"
      >
        <div class="flex_column width_100 align_center">
          <div class="flex_row width_100 about_history_title_div">
            <p class="about_history_title">医生团队</p>
            <div class="flex_row about_history_tab_div">
              <div
                :class="doctorTeamTab == 0 ? 'about_tab_selected' : 'about_tab'"
                @click="switchDoctorTeam(0)"
              >
                院内专家
              </div>
              <!-- <div
                :class="doctorTeamTab == 1 ? 'about_tab_selected' : 'about_tab'"
                style="margin-left: 43px"
                @click="switchDoctorTeam(1)"
              >
                特邀专家
              </div> -->
            </div>
          </div>
          <div class="line"></div>
          <div
            class="flex_row width_100 about_history_title_div overflow_hidden"
            style="margin-top: 27px"
          >
            <div
              class="flex_row"
              :style="doctorTeamTab == 0 ? { opacity: 1 } : { opacity: 0 }"
            >
              <div class="flex_column width_100">
                <div
                  class="flex_row width_100"
                  style="padding-top: 44px; background-color: white; z-index: 2"
                >
                  <!-- 最上面头像 -->
                  <div
                    v-for="(item, index) in doctorTeamDoctors"
                    :key="index"
                    class="flex_row align_center"
                    style="width: 295px"
                    @click="clickDoctorTeam(index)"
                    v-if="item.name != '林育华'"
                  >
                    <img :src="item.headIcon" class="doctor_team_avatar" />
                    <div class="flex_column" style="margin-left: 20px">
                      <label class="doctor_team_name">{{ item.name }}</label>
                      <p
                        class="doctor_team_info"
                        style="overflow: hidden; height: 30px"
                      >
                        {{ item.position }}
                      </p>
                    </div>
                  </div>
                </div>

                <!-- 下面的医生 -->
                <div
                  class="flex_column doctor_team_info2_div"
                  :style="{ top: doctorTeamTop + 'px' }"
                >
                  <div
                    v-for="(item, index) in doctorTeamDoctors"
                    :key="index"
                    class="flex_column"
                    style="margin-top: 81px"
                    v-if="item.name != '林育华'"
                  >
                    <div class="flex_row">
                      <div class="doctor_team_img_div">
                        <img :src="item.img" />
                      </div>
                      <div class="flex_column" style="margin-left: 120px">
                        <div class="flex_row" style="align-items: end">
                          <label class="doctor_team_name2">{{
                            item.name
                          }}</label>
                          <p
                            class="doctor_team_info2"
                            style="margin-left: 10px"
                          >
                            {{ item.position }}
                          </p>
                        </div>
                        <div
                          class="doctor_team_line"
                          style="margin-top: 12px"
                        ></div>
                        <div class="doctor_team_info3" style="margin-top: 11px">
                          {{ item.positionInfo }}
                        </div>
                        <div class="doctor_team_info4" style="margin-top: 40px">
                          {{ item.intro }}
                        </div>
                        <div
                          class="flex_row align_center"
                          style="margin-top: 59px; justify-content: end"
                          v-if="item.certificate"
                        >
                          <div class="doctor_team_info3" style="flex: 1">
                            荣誉证书
                          </div>
                          <img
                            src="../assets/images/ic_certificate_left.png"
                            style="width: 10px; height: 18px"
                          />
                          <img
                            src="../assets/images/ic_certificate_right.png"
                            style="width: 10px; height: 18px; margin-left: 23px"
                          />
                        </div>
                        <div class="flex_row" style="margin-top: 19px">
                          <div
                            v-for="(cer, cerIndex) in item.certificate"
                            :key="cer"
                            class="flex_column justify_center align_center"
                            :style="
                              cerIndex > 0
                                ? { 'margin-left': '35px' }
                                : { 'margin-left': '0px' }
                            "
                          >
                            <div class="doctor_team_certificate">
                              <img :src="cer.img" />
                            </div>
                            <label
                              class="doctor_team_certificate_text"
                              style="margin-top: 6px"
                              >{{ cer.name }}</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="line" style="margin-top: 83px"></div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="flex_row position_absolute overflow_hidden"
              :style="doctorTeamTab == 1 ? { opacity: 1 } : { opacity: 0 }"
            >
              <div class="flex_column width_100">
                <div
                  class="flex_row width_100"
                  style="padding-top: 44px; background-color: white; z-index: 2"
                >
                  <!-- 最上面头像 -->
                  <div
                    v-for="(item, index) in doctorTeamDoctors2"
                    :key="index"
                    class="flex_row align_center"
                    style="width: 295px"
                    @click="clickDoctorTeam(index)"
                  >
                    <img :src="item.headIcon" class="doctor_team_avatar" />
                    <div class="flex_column" style="margin-left: 20px">
                      <label class="doctor_team_name">{{ item.name }}</label>
                      <p
                        class="doctor_team_info"
                        style="overflow: hidden; height: 30px"
                      >
                        {{ item.position }}
                      </p>
                    </div>
                  </div>
                </div>

                <!-- 下面的医生 -->
                <div
                  class="flex_column doctor_team_info2_div"
                  :style="{ top: doctorTeamTop + 'px' }"
                >
                  <div
                    v-for="(item, index) in doctorTeamDoctors2"
                    :key="index"
                    class="flex_column"
                    style="margin-top: 81px"
                  >
                    <div class="flex_row">
                      <div class="doctor_team_img_div">
                        <img :src="item.img" />
                      </div>
                      <div class="flex_column" style="margin-left: 120px">
                        <div class="flex_row" style="align-items: end">
                          <label class="doctor_team_name2">{{
                            item.name
                          }}</label>
                          <p
                            class="doctor_team_info2"
                            style="margin-left: 10px"
                          >
                            {{ item.position }}
                          </p>
                        </div>
                        <div
                          class="doctor_team_line"
                          style="margin-top: 12px"
                        ></div>
                        <div class="doctor_team_info3" style="margin-top: 11px">
                          {{ item.positionInfo }}
                        </div>
                        <div class="doctor_team_info4" style="margin-top: 40px">
                          {{ item.intro }}
                        </div>
                        <div
                          class="flex_row align_center"
                          style="margin-top: 59px; justify-content: end"
                          v-if="item.certificate"
                        >
                          <div class="doctor_team_info3" style="flex: 1">
                            荣誉证书
                          </div>
                          <img
                            src="../assets/images/ic_certificate_left.png"
                            style="width: 10px; height: 18px"
                          />
                          <img
                            src="../assets/images/ic_certificate_right.png"
                            style="width: 10px; height: 18px; margin-left: 23px"
                          />
                        </div>
                        <div class="flex_row" style="margin-top: 19px">
                          <div
                            v-for="(cer, cerIndex) in item.certificate"
                            :key="cer"
                            class="flex_column justify_center align_center"
                            :style="
                              cerIndex > 0
                                ? { 'margin-left': '35px' }
                                : { 'margin-left': '0px' }
                            "
                          >
                            <div class="doctor_team_certificate">
                              <img :src="cer.img" />
                            </div>
                            <label
                              class="doctor_team_certificate_text"
                              style="margin-top: 6px"
                              >{{ cer.name }}</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="line" style="margin-top: 83px"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 医生团队 -->

      <!-- 矫正流程 -->
      <div
        v-if="selectedTab == 3"
        class="flex_column justify_center align_center"
        style="margin-top: 108px"
      >
        <div class="flex_column width_100 align_center about_history_title_div">
          <!-- <div class="flex_row width_100">
            <p class="about_history_title">预约就诊</p>
          </div> -->
          <!-- <div class="flex_row width_100" style="margin-top: 35px;">
            <div
              class="flex_row align_center justify_center process_top_div"
              style="flex:1;"
            >
              <div class="process_qr_code_div">
                <img src="../assets/images/ic_process_qr_code1.png" />
              </div>
              <div
                class="flex_column justify_center align_center"
                style="margin-left: 89px;"
              >
                <img
                  src="../assets/images/ic_process_qr_code1_1.png"
                  style="width: 121px;height: 147px;"
                />
                <div class="about_tab_selected">小程序挂号预约</div>
              </div>
            </div>
            <div
              class="flex_row align_center justify_center process_top_div"
              style="flex:1;margin-left: 20px;"
            >
              <div class="process_qr_code_div">
                <img src="../assets/images/ic_process_qr_code2.png" />
              </div>
              <div
                class="flex_column justify_center align_center"
                style="margin-left: 89px;"
              >
                <img src="../assets/images/ic_process_qr_code2_2.png" />
                <div class="about_tab_selected">客服微信</div>
              </div>
            </div>
          </div> -->
          <div class="flex_row width_100">
            <p class="about_history_title">{{ flow.title1 }}</p>
          </div>
          <div class="line"></div>
          <p class="doctor_team_certificate_text" style="margin-top: 35px">
            {{ flow.content1 }}
          </p>
          <div class="flex_row" style="flex-wrap: wrap; margin-top: 12px">
            <div
              v-for="(item, index) in process1"
              :key="index"
              class="flex_column justify_center align_center"
              style="margin-top: 35px"
              :style="{ 'margin-left': index % 4 == 0 ? '0px' : '20px' }"
            >
              <img :src="item.img" class="process_info2_img" />
              <label class="process_info2_text" style="margin-top: 15px">{{
                item.title
              }}</label>
            </div>
          </div>
          <div
            class="flex_row width_100"
            style="margin-top: 47px; height: 750px"
          >
            <div class="flex_row process_info2_table" style="flex: 1">
              <div class="flex_row" style="flex: 1">
                <div
                  class="flex_column width_100 height_100"
                  style="
                    border-right: 1px;
                    border-style: solid;
                    border-color: #cccccc;
                  "
                >
                  <div class="process_info2_title width_100">
                    {{ flow.tableTitle1 }}
                  </div>
                  <div
                    v-for="(item, index) in flow.tableContent1"
                    class="process_info2_item doctor_team_certificate_text"
                  >
                    {{ item.title }}
                  </div>
                </div>
              </div>
              <div class="flex_row" style="flex: 1">
                <div class="flex_column width_100 height_100">
                  <div class="process_info2_title width_100">
                    {{ flow.tableTitle2 }}
                  </div>
                  <div
                    v-for="(item, index) in flow.tableContent2"
                    class="process_info2_item doctor_team_certificate_text"
                  >
                    {{ item.title }}
                  </div>
                </div>
              </div>
            </div>
            <div class="flex_column" style="flex: 1; margin-left: 20px">
              <div class="flex_row process_info2_table" style="flex: 1">
                <div class="flex_row" style="flex: 1">
                  <div
                    class="flex_column width_100 height_100"
                    style="
                      border-right: 1px;
                      border-style: solid;
                      border-color: #cccccc;
                    "
                  >
                    <div class="process_info2_title width_100">
                      {{ flow.tableTitle3 }}
                    </div>
                    <div
                      v-for="(item, index) in flow.tableContent3"
                      class="process_info2_item doctor_team_certificate_text"
                    >
                      {{ item.title }}
                    </div>
                  </div>
                </div>
                <div class="flex_row" style="flex: 1">
                  <div class="flex_column width_100 height_100">
                    <div class="process_info2_title width_100">
                      {{ flow.tableTitle4 }}
                    </div>
                    <div
                      v-for="(item, index) in flow.tableContent4"
                      class="process_info2_item doctor_team_certificate_text"
                    >
                      {{ item.title }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex_column process_info2_table">
                <div class="process_info2_title width_100">
                  {{ flow.tableTitle5 }}
                </div>
                <div class="flex_row">
                  <div
                    v-for="(item, index) in flow.tableContent5"
                    class="process_info2_item doctor_team_certificate_text"
                    style="height: 98px"
                  >
                    {{ item.title }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex_row width_100" style="margin-top: 47px">
            <p class="about_history_title">{{ flow.title2 }}</p>
          </div>
          <div class="line"></div>
          <p class="doctor_team_certificate_text" style="margin-top: 35px">
            {{ flow.content2 }}
          </p>
          <div
            class="flex_row"
            style="flex-wrap: wrap; margin-top: 12px; padding-bottom: 50px"
          >
            <div
              v-for="(item, index) in process2"
              :key="index"
              class="flex_column justify_center align_center"
              style="margin-top: 35px"
              :style="{ 'margin-left': index % 4 == 0 ? '0px' : '20px' }"
            >
              <img :src="item.img" class="process_info2_img" />
              <label class="process_info2_text" style="margin-top: 15px">{{
                item.title
              }}</label>
            </div>
          </div>
        </div>
      </div>

      <!-- 术式介绍 -->
      <div
        v-if="selectedTab == 4"
        class="flex_column justify_center align_center"
        style="margin-top: 108px"
      >
        <div class="flex_column width_100 align_center">
          <div class="flex_row width_100 about_history_title_div">
            <p class="about_history_title">{{ operation.title1 }}</p>
            <div class="flex_row about_history_tab_div">
              <div
                v-for="(item, index) in recommends"
                :key="index"
                :class="
                  selectedRecommend == index
                    ? 'about_tab_selected'
                    : 'about_tab'
                "
                style="margin-left: 60px"
                @click="switchRecommend(index)"
              >
                {{ item.btnText }}
              </div>
            </div>
          </div>
          <div class="line"></div>
          <div
            class="flex_row width_100 about_history_title_div overflow_hidden"
            style="margin-top: 44px"
          >
            <div class="flex_row">
              <div class="flex_column width_100">
                <label class="recommend_title">{{
                  recommends[selectedRecommend].title
                }}</label>
                <p class="recommend_info" style="margin-top: 16px">
                  {{ recommends[selectedRecommend].content }}
                </p>
                <div class="flex_row align_center">
                  <div class="recommend_video_div">
                    <Video
                      :src="recommends[selectedRecommend].video"
                      :second="1"
                      :width="580"
                      :height="331"
                    />
                  </div>
                  <div
                    class="flex_column"
                    style="margin-left: 120px; width: 480px"
                  >
                    <label class="recommend_info_title">{{
                      recommends[selectedRecommend].title2
                    }}</label>
                    <p class="recommend_info" style="margin-top: 4px">
                      {{ recommends[selectedRecommend].content2 }}
                    </p>
                    <label
                      class="recommend_info_title"
                      style="margin-top: 41px"
                      >{{ recommends[selectedRecommend].title3 }}</label
                    >
                    <p class="recommend_info" style="margin-top: 4px">
                      {{ recommends[selectedRecommend].content3 }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div
              class="flex_row position_absolute overflow_hidden"
              style="opacity: 0;"
            >
              <div class="flex_column width_100">
                <label class="recommend_title">{{
                  recommends[lastSelectedRecommend].title
                }}</label>
                <p class="recommend_info" style="margin-top: 16px;">
                  {{ recommends[lastSelectedRecommend].content }}
                </p>
                <div class="flex_row align_center">
                  <div class="recommend_video_div">
                    <Video
                      :src="recommends[lastSelectedRecommend].video"
                      :second="3"
                      :width="580"
                      :height="331"
                    />
                  </div>
                  <div
                    class="flex_column"
                    style="margin-left: 120px;width: 480px;"
                  >
                    <label class="recommend_info_title">{{ recommends[lastSelectedRecommend].title2 }}</label>
                    <p class="recommend_info" style="margin-top: 4px;">
                      {{ recommends[lastSelectedRecommend].content2 }}
                    </p>
                    <label
                      class="recommend_info_title"
                      style="margin-top: 41px;"
                      >{{ recommends[lastSelectedRecommend].title3 }}</label
                    >
                    <p class="recommend_info" style="margin-top: 4px;">
                      {{ recommends[lastSelectedRecommend].content3 }}
                    </p>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
          <div
            class="flex_column width_100 about_history_title_div"
            style="margin-top: 44px; margin-bottom: 44px"
          >
            <label class="recommend_title">{{ operation.title2 }}</label>
            <div class="flex_column recommend2_div" style="margin-top: 41px">
              <div class="flex_row">
                <div
                  v-for="(item, index) in operation.tableTitle"
                  :key="index"
                  class="recommend2_title recommend2_item_border"
                >
                  {{ item.title }}
                </div>
              </div>
              <div v-for="item in recommends2" :key="item" class="flex_row">
                <div
                  v-for="recommend in item"
                  :key="recommend"
                  class="recommend2_item recommend2_item_border"
                  :style="{ flex: recommend.flex }"
                >
                  {{ recommend.title }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 术式介绍 -->

      <!-- 常见问题 -->
      <div
        v-if="selectedTab == 5"
        class="flex_column justify_center align_center"
        style="margin-top: 108px"
      >
        <div class="flex_column width_100 align_center">
          <div class="flex_row width_100 about_history_title_div">
            <p class="about_history_title">{{ questionPage.title1 }}</p>
            <div class="flex_row about_history_tab_div">
              <div
                v-for="(item, index) in questions"
                :class="
                  selectedQuestion == index ? 'about_tab_selected' : 'about_tab'
                "
                @click="switchQuestion(index)"
                style="margin-right: 50px"
              >
                {{ item.btnText }}
              </div>
            </div>
          </div>
          <div class="line"></div>
          <div
            class="flex_row width_100 about_history_title_div overflow_hidden"
            style="margin-top: 27px"
          >
            <div
              class="flex_row"
              v-for="(item, index) in questions"
              v-if="selectedQuestion == index"
            >
              <div class="flex_column width_100">
                <div
                  v-for="question in item.content"
                  :key="index"
                  class="flex_column"
                >
                  <label class="question_title">{{ question.question }}</label>
                  <div class="question_content" v-html="question.answer"></div>
                  <div class="line"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="flex_row width_100 about_history_title_div"
            style="margin-top: 44px"
          >
            <p class="about_history_title">{{ questionPage.title2 }}</p>
          </div>
          <div class="line"></div>
          <div
            class="flex_row about_history_title_div"
            style="flex-wrap: wrap; margin-bottom: 60px"
          >
            <div
              v-for="(item, index) in questionVideos"
              :key="item"
              style="margin-top: 44px"
              class="flex_column align_center justify_center"
              :style="
                index % 3 == 0
                  ? { 'margin-left': '0px' }
                  : { 'margin-left': '20px' }
              "
            >
              <div class="flex_row align_center justify_center question_video">
                <Video
                  :src="item.video"
                  :second="0"
                  :width="380"
                  :height="220"
                />
              </div>
              <label class="question_video_text">{{ item.title }}</label>
            </div>
          </div>
        </div>
        <!-- 常见问题 -->
      </div>
    </div>
    <!-- 手机端 -->
    <div class="phone" v-else>
      <div class="phone__head" :class="{ phone_fixed: isShowMenu }">
        <div class="phone__flex">
          <div class="phone__title">
            <div class="">
              <img src="../assets/images/ic_phone_logo.webp" />
            </div>
            <div class="col-md-7 tab_div">
              <div>
                <img
                  class="more"
                  :src="
                    isShowMenu
                      ? require('../assets/images/x.png')
                      : require('../assets/images/more.png')
                  "
                  @click="openMenu()"
                />
              </div>
            </div>
          </div>
          <div
            class="menu_layout"
            :class="{
              menu_layout_open: isShowMenu,
              menu_layout_close: !isShowMenu
            }"
          >
            <div
              class="menu_item"
              v-for="(item, index) in tabs"
              @click="tabChoose(index)"
            >
              <div class="menu_line"></div>
              <div
                class="menu_text"
                :class="{ menu_text_selected: active == index }"
              >
                {{ item }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="body_margin_top">
        <div>
          <el-carousel
            height="230px"
            :height="bannerHeight + 'px'"
            arrow="never"
          >
            <el-carousel-item v-for="item in banner">
              <img
                ref="bannerImg"
                :src="item.phoneImg"
                class="phone_img"
                @load="imgLoad()"
              />
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- 手机端tab -->
        <div class="tabsList">
          <div style="display: flex; flex-direction: column">
            <div
              class="hospital_profile_tab_phone"
              v-for="(item, index) in hospiatlProfiles"
              @click="profileClickPhone(index)"
            >
              <div class="hospital_profile_tab_title">
                <div class="hospital_profile_text_phone">{{ item.title }}</div>
                <img
                  class="hospiatl_profile_img_phone"
                  :class="{ hospiatl_profile_img_selected: item.isSelected }"
                  :src="
                    item.isSelected
                      ? require('../assets/images/ic_down.png')
                      : require('../assets/images/ic_right.png')
                  "
                />
              </div>
              <div
                class="hospital_profile_tab_content_phone"
                :class="{
                  hospital_profile_tab_content_phone_selected: item.isSelected
                }"
              >
                <div class="hospital_profile_tab_content_phone_text">
                  {{ item.content }}
                </div>
                <img class="hospital_profile_img_phone" :src="item.img" />
              </div>
            </div>
          </div>
        </div>

        <!-- 手机端 doctor -->
        <div class="doctor_layout_phone">
          <div class="doctor_img_bg_phone">
            <img
              :src="doctors[lastSelectDoctor].phoneImg"
              class="doctor_img_phone"
              :class="{ hospital_profile_img_fade_out2: isSwithingDoctor }"
              style="opacity: 0; width: 100%"
            />
            <img
              :src="doctors[selectedDoctor].phoneImg"
              class="doctor_img_phone"
              :class="{ hospital_profile_img_fade_in: isSwithingDoctor }"
              style="position: absolute"
            />
          </div>
          <div class="doctor_info_layout_phone">
            <div
              class="doctor_text_layout_phone"
              style="opacity: 0"
              :class="{ hospital_profile_img_fade_in: isSwithingDoctor }"
            >
              <div class="doctor_name_layout_phone">
                <div class="doctor_name_phone">
                  {{ doctors[selectedDoctor].name }}
                </div>
                <div
                  class="doctor_position_phone"
                  v-for="(item, index) in doctors[selectedDoctor].position"
                >
                  {{ item }}
                </div>
              </div>
              <div class="doctor_line"></div>
              <div class="doctor_honer_phone">
                {{ doctors[selectedDoctor].honor }}
              </div>
              <div class="doctor_info_phone">
                <div
                  class="doctor_info_item_phone"
                  v-for="(item, index) in doctors[selectedDoctor].info"
                >
                  {{ item }}
                </div>
              </div>
            </div>
            <div
              class="doctor_text_layout_phone"
              style="position: absolute"
              :class="{ hospital_profile_img_fade_in: isSwithingDoctor }"
            >
              <div class="doctor_name_layout_phone">
                <div class="doctor_name_phone">
                  {{ doctors[selectedDoctor].name }}
                </div>
                <div
                  class="doctor_position_phone"
                  v-for="(item, index) in doctors[selectedDoctor].position"
                >
                  {{ item }}
                </div>
              </div>
              <div class="doctor_line"></div>
              <div class="doctor_honer_phone">
                {{ doctors[selectedDoctor].honor }}
              </div>
              <div class="doctor_info_phone">
                <div
                  class="doctor_info_item_phone"
                  v-for="(item, index) in doctors[selectedDoctor].info"
                >
                  {{ item }}
                </div>
              </div>
            </div>
            <div class="doctor_list">
              <div
                class="doctor_list_item_phone"
                :class="{ doctor_list_item_selected: index == switchDoctor }"
                v-for="(item, index) in doctors"
                @click="switchDoctor(index)"
              >
                <img
                  :src="doctors[index].iconImg"
                  class="doctor_list_item_phone"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- 手机端 step -->
        <div style="display: flex; flex-direction: column">
          <div class="doctor_step_layout_phone">
            <div
              class="doctor_step_phone"
              v-for="(item, index) in steps"
              @mouseenter="stepMouseMovePhone(index)"
            >
              <div style="display: flex">
                <img
                  :src="item.img"
                  class="doctor_step_img"
                  :ref="'step_image' + index"
                />
                <div
                  class="doctor_step_img_mask_phone"
                  style="position: absolute"
                  :class="{ doctor_step_img_mask_fade_out: item.isSelected }"
                ></div>
              </div>
              <div
                class="doctor_step_text"
                :class="{ doctor_step_text_selected: item.isSelected }"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
        </div>

        <div class="bottom_layout_phone">
          <div class="bottom_text_phone">
            联系地址：深圳市南山区高新南一道6号TCL大厦A座210<br /><br />

            交通线路：<br />
            地铁1号线至高新园B出口，在十字路口右转直行20米左右，上楼梯前行100米左右即可到达门诊正门。<br /><br />

            乘坐235路、323路、324路等公交路线在“大冲①”下车，往前经过十字路口后向左直行20米左右，上楼梯前行100米左右即可到达门诊正门。<br /><br />

            乘坐72路、235路、M530路等公交路线在“高新园地铁站”下，往万象天地方向直行20米左右，向后上楼梯前行100米左右即可到达门诊正门。
          </div>
        </div>

        <div class="col-md-12 text-center">
          <label class="title_text" style="margin-left: 0px"
            >ICP备案：<a href="https://beian.miit.gov.cn/"
              >粤ICP备2021179031号-1</a
            ></label
          >
        </div>
      </div>
    </div>
    <webview v-if="type_v"> </webview>
  </div>
</template>

<script src="../assets/js/bootstrap"></script>
<script src="../assets/js/fontSize.js"></script>
<script>
import $ from 'jquery'
import axios from 'axios'
import Video from './Video'

export default {
  components: {
    Video
  },
  data() {
    return {
      type_v: false,
      screenWidth: 1,
      isShowTitle: true,
      isShowTab: true,
      active: 1,
      left: 0,
      tabSelectedWidth: 0,
      selectedTab: 0,
      tabTimerId: -1,
      tabs: [
        '首页',
        '关于西柚',
        '医生团队',
        '术式介绍',
        '常见问题',
        '新闻资讯'
      ],
      banner: null,
      showIndividual: {},
      showDev: false, //PC或手机端显示
      seletcedBanner: 0,
      bannerHeight: 0,
      bannerAnimation: 0,
      bannerDirection: 2,
      isAutoBanner: -1,
      isShowBannerBtn: false,
      timerId: -1,
      bannerTimerId: -1,
      hospiatlProfiles: null,
      doctors: null,
      selectedProfile: 0,
      lastSelectedProfile: 0,
      isSwithingProfileImg: false,
      isAutoProfile: true,
      selectedDoctor: 0,
      lastSelectDoctor: 0,
      isSwithingDoctor: false,
      steps: null,
      isMouseMoveStep: false,
      stepLeft: 410,
      floats: [
        // {
        //   img: require('../assets/images/float1.png'),
        //   selectedImg: require('../assets/images/float1_selected.png'),
        //   showImg: require('../assets/images/float1_show.png'),
        //   text: '线上咨询',
        //   isShow: false
        // },
        {
          img: require('../assets/images/float2.png'),
          selectedImg: require('../assets/images/float2_selected.png'),
          showImg: require('../assets/images/float2_show.png'),
          text: '17727907108',
          isShow: false
        },
        {
          img: require('../assets/images/float3.png'),
          selectedImg: require('../assets/images/float3_selected.png'),
          showImg: require('../assets/images/float3_show.png'),
          text: '微信咨询',
          image: require('../assets/images/qr_code.png'),
          isShow: false
        }
      ],
      selectedFloat: 0,
      switchingFloat: -1,
      floatWidth: 60,
      floatHeight: 60,
      isShowMenu: false,
      startAnimation: false,
      isShowAboutTitle: true,
      about: null,
      aboutHistoryTab: 0,
      years: [],
      selectedYear: 1,
      lastSelectedYear: 0,
      yearTop: 0,
      startYearInfoAnimation: false,
      years2: [],
      selectedYear2: 1,
      year2Left: 200,
      aboutEquipmentTab: 0,
      equipments1: [],
      equipments2: [],
      doctorTeamTab: 0,
      doctorTeamDoctors: [],
      doctorTeamTop: 0,
      doctorTeamDoctors2: [],
      flow: null,
      process1: [],
      process2: [],
      selectedRecommend: 0,
      lastSelectedRecommend: 0,
      startRecommendAnimation: false,
      operation: null,
      recommends: null,
      recommends2: [],
      selectedQuestion: 0,
      questionPage: null,
      questions: [],
      questionVideos: [],
      bannerTimerId: -1
    }
  },
  created() {
    if (document.body.clientWidth > 1000) {
      this.showDev = true
    } else {
      this.showDev = false
    }
    window.onresize = () => {
      return (() => {
        if (document.body.clientWidth > 1000) {
          this.showDev = true
          this.bodyScale()
        } else {
          this.showDev = false
        }
      })()
    }

    window.onscroll = () => {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      let scrollStep = scrollTop - this.oldScrollTop
      this.oldScrollTop = scrollTop
      if (scrollStep > 0) {
        this.isShowTab = false
      } else {
        this.isShowTab = true
      }
      if (scrollTop <= 80) {
        this.isShowTitle = true
      } else {
        this.isShowTitle = false
      }
    }
    setTimeout(() => {
      this.active = 0
      let rect = this.$refs['tab' + 1].getBoundingClientRect()
      this.left = rect.left
      this.tabSelectedWidth = rect.right - rect.left
      if (this.selectedTab == 0) {
        let rect2 = this.$refs[`step_image0`][0].getBoundingClientRect()
        let lineRect = this.$refs['line'].getBoundingClientRect()
        let width = rect2.right - rect2.left
        let lineWidth = lineRect.right - lineRect.left
        this.stepLeft = rect2.left + (width - lineWidth) / 2
      }
    }, 10)
    // float轮播
    setInterval(() => {
      if (this.switchingFloat == -1 && this.showDev && this.selectedTab == 0) {
        if (this.selectedFloat == this.floats.length - 1) {
          this.selectedFloat = 0
        } else {
          this.selectedFloat += 1
        }
      }
    }, 1500)
    this.initHome()
  },
  methods: {
    go_banner(item) {
      // console.log('item', item)
      if (item.id == 5) {
        // window.location.href = 'https://realsee.cn/wO22yPmv'
        window.open('https://realsee.cn/wO22yPmv', '_blank')
      }
    },
    go_webview(item) {
      if (item.text == '线上咨询') {
        this.type_v = true
      }
    },
    tabIndividual(index) {
      this.showIndividual = this.doctors[index]
    },
    tabClick(index) {
      this.selectedTab = index
      clearInterval(this.bannerTimerId)
      this.bannerAnimation = 0
      if (index == 0) {
        this.bannerTimerId = setInterval(() => {
          if (this.isAutoBanner == -1 && this.selectedTab == 0) {
            this.switchBanner(2)
          }
        }, 2000)
      }
      if (index == 1) {
        this.initAbout()
      }
      if (index == 2) {
        this.initDoctor()
      }
      if (index == 3) {
        this.initFlow()
      }
      if (index == 4) {
        this.initOperation()
      }
      if (index == 5) {
        this.initQuestion()
      }
    },
    bodyScale() {
      var devicewidth = document.documentElement.clientWidth
      var scale = devicewidth / 1920 // 分母——设计稿的尺寸宽度
      document.body.style.zoom = scale
    },
    tabMouseMove(e) {
      clearTimeout(this.tabTimerId)
      this.active = e
      let rect = this.$refs['tab' + e].getBoundingClientRect()
      this.left = rect.left
      this.tabSelectedWidth = rect.right - rect.left
    },
    tabMouseLeave() {
      this.tabTimerId = setTimeout(() => {
        this.active = this.selectedTab + 1
        let rect = this.$refs['tab' + this.active].getBoundingClientRect()
        this.left = rect.left
        this.tabSelectedWidth = rect.right - rect.left
      }, 500)
    },
    tabChoose(index) {
      this.active = index
    },
    bannerMouseMove() {
      clearTimeout(this.bannerTimerId)
      this.isShowBannerBtn = true
    },
    bannerMouseLeave() {
      this.bannerTimerId = setTimeout(() => {
        this.isShowBannerBtn = false
      }, 2000)
    },
    getBanner1Style() {
      if (this.bannerDirection == 2) {
        return (
          'animation: banner_image_out' + this.bannerAnimation + ' .5s ease-in;'
        )
      } else {
        return (
          'animation: banner_image_out_left' +
          this.bannerAnimation +
          ' .5s ease-in;'
        )
      }
    },
    getBanner2Style() {
      if (this.bannerDirection == 2) {
        return (
          'animation: banner_image' + this.bannerAnimation + ' .5s ease-in;'
        )
      } else {
        return (
          'animation: banner_image_left' +
          this.bannerAnimation +
          ' .5s ease-in;'
        )
      }
    },
    switchBanner(direction) {
      clearTimeout(this.isAutoBanner)
      this.bannerDirection = direction
      this.bannerAnimation = this.bannerAnimation == 1 ? 2 : 1
      if (direction == 1) {
        if (this.seletcedBanner == 0) {
          this.seletcedBanner = this.banner.length - 1
        } else {
          this.seletcedBanner -= 1
        }
      } else {
        if (this.seletcedBanner == this.banner.length - 1) {
          this.seletcedBanner = 0
        } else {
          this.seletcedBanner += 1
        }
      }
      this.isAutoBanner = setTimeout(() => {
        this.isAutoBanner = -1
      }, 2000)
    },
    profileClick(index) {
      this.isAutoProfile = false
      clearTimeout(this.timerId)
      for (let i in this.hospiatlProfiles) {
        this.hospiatlProfiles[i].isSelected = i == index
      }
      this.isSwithingProfileImg = false
      this.lastSelectedProfile = this.selectedProfile
      this.selectedProfile = index
      this.isSwithingProfileImg = true
      this.timerId = setTimeout(() => {
        this.isSwithingProfileImg = false
      }, 500)
    },
    profileLeave(index) {
      this.isAutoProfile = true
    },
    profileClickPhone(index) {
      clearTimeout(this.timerId)
      for (let i in this.hospiatlProfiles) {
        this.hospiatlProfiles[i].isSelected =
          i == index ? !this.hospiatlProfiles[i].isSelected : false
      }
      this.isSwithingProfileImg = false
      this.lastSelectedProfile = this.selectedProfile
      this.selectedProfile = index
      this.isSwithingProfileImg = true
      this.timerId = setTimeout(() => {
        this.isSwithingProfileImg = false
      }, 500)
    },
    switchDoctor(index) {
      clearTimeout(this.timerId)
      this.isSwithingDoctor = false
      this.lastSelectDoctor = this.selectedDoctor
      this.selectedDoctor = index
      this.isSwithingDoctor = true
      this.timerId = setTimeout(() => {
        this.isSwithingDoctor = false
      }, 500)
      this.selectedDoctor = index
    },
    switchFirstDoctor() {
      clearTimeout(this.timerId)
      this.isSwithingDoctor = false
      this.lastSelectDoctor = this.selectedDoctor
      this.selectedDoctor = 0
      this.isSwithingDoctor = true
      this.timerId = setTimeout(() => {
        this.isSwithingDoctor = false
      }, 500)
      this.selectedDoctor = 0
    },
    stepMouseMove(index) {
      this.isMouseMoveStep = true
      let rect = this.$refs[`step_image${index}`][0].getBoundingClientRect()
      let lineRect = this.$refs['line'].getBoundingClientRect()
      let width = rect.right - rect.left
      let lineWidth = lineRect.right - lineRect.left
      this.stepLeft = rect.left + (width - lineWidth) / 2
      for (let i in this.steps) {
        this.steps[i].isSelected = i == index
      }
    },
    stepMouseLeave() {
      this.isMouseMoveStep = false
    },
    stepMouseMovePhone(index) {
      // for (let i in this.steps) {
      //   this.steps[i].isSelected = i == index;
      // }
    },
    floatMouseMove(index) {
      this.switchingFloat = index
      this.floatWidth = 210
      if (this.floats[index].image) {
        this.floatHeight = 246
      }
    },
    floatMouseLeave() {
      this.switchingFloat = -1
      this.floatWidth = 60
      this.floatHeight = 60
    },
    openMenu() {
      this.isShowMenu = !this.isShowMenu
    },
    imgLoad() {
      this.$nextTick(() => {
        this.bannerHeight =
          this.$refs.bannerImg && this.$refs.bannerImg.length
            ? this.$refs.bannerImg[0].height
            : 0 //关键的一步
      })
    },
    switchAboutHistory(type) {
      this.aboutHistoryTab = type
    },
    switchAboutEquipment(type) {
      this.aboutEquipmentTab = type
    },
    switchDoctorTeam(type) {
      this.doctorTeamTab = type
    },
    switchQuestion(type) {
      this.selectedQuestion = type
    },
    switchRecommend(type) {
      this.startRecommendAnimation = false
      this.lastSelectedRecommend = this.selectedRecommend
      this.selectedRecommend = type
      setTimeout(() => {
        this.startRecommendAnimation = true
      }, 100)
    },
    aboutHistoryYear(index) {
      this.startYearInfoAnimation = false
      this.lastSelectedYear = this.selectedYear
      if (index < 0) {
        this.selectedYear = 0
        return
      } else if (index > this.years.length - 1) {
        this.selectedYear = this.years.length - 1
        return
      } else {
        this.selectedYear = index
      }
      let rect = this.$refs['year' + index][0].getBoundingClientRect()
      let height = rect.bottom - rect.top
      this.yearTop = -(index * height) + height
      setTimeout(() => {
        this.startYearInfoAnimation = true
      }, 100)
    },
    clickYear2(index) {
      let offset = this.selectedYear2 - index < 0 ? -50 : 50
      this.year2Left += (this.selectedYear2 - index) * 400 + offset
      this.selectedYear2 = index
      setTimeout(() => {
        this.year2Left -= offset
      }, 500)
    },
    clickDoctorTeam(index) {
      console.log('index', index)

      let offset = -50
      if (index == 3) {
        index = 2
      }
      this.doctorTeamTop = -(index * 860 - offset)
      setTimeout(() => {
        this.doctorTeamTop -= offset
      }, 500)
    },
    async initHome() {
      axios.get(this.BASE_URL + '/system/banner/list', {}).then(res => {
        this.banner = res.data.rows
        // banner轮播
        this.bannerTimerId = setInterval(() => {
          if (this.isAutoBanner == -1 && this.selectedTab == 0) {
            this.switchBanner(2)
          }
        }, 2000)
      })

      axios.get(this.BASE_URL + '/system/intro/list', {}).then(res => {
        this.hospiatlProfiles = res.data.rows
        // hospatil轮播
        setInterval(() => {
          if (this.isAutoProfile && this.showDev && this.selectedTab == 0) {
            clearTimeout(this.timerId)
            let index = 0
            for (let i = 0; i < this.hospiatlProfiles.length; i++) {
              if (this.hospiatlProfiles[i].isSelected) {
                index = i
              }
            }
            if (index == this.hospiatlProfiles.length - 1) {
              index = 0
            } else {
              index += 1
            }
            for (let i in this.hospiatlProfiles) {
              this.hospiatlProfiles[i].isSelected = i == index
            }
            this.isSwithingProfileImg = false
            this.lastSelectedProfile = this.selectedProfile
            this.selectedProfile = index
            this.isSwithingProfileImg = true
            this.timerId = setTimeout(() => {
              this.isSwithingProfileImg = false
            }, 500)
          }
        }, 2000)
      })

      axios
        .get(this.BASE_URL + '/system/doctor/list?isShowHome=2', {})
        .then(res => {
          // this.banner = res.data.rows;
          this.doctors = res.data.rows

          this.tabIndividual(0)
        })

      axios.get(this.BASE_URL + '/system/flow/list?type=1', {}).then(res => {
        this.steps = res.data.rows
        for (let i = 0; i < this.steps.length; i++) {
          ;(this.steps[i].icon = require('../assets/images/ic_step' +
            (i + 1) +
            '.png')),
            (this.steps[i].selectedIcon = require('../assets/images/ic_step' +
              (i + 1) +
              '_selected.png'))
        }
        // step轮播
        setInterval(() => {
          if (!this.isMouseMoveStep && this.selectedTab == 0) {
            let index = 0
            for (let i = 0; i < this.steps.length; i++) {
              if (this.steps[i].isSelected) {
                index = i
              }
            }
            if (index == this.steps.length - 1) {
              index = 0
            } else {
              index += 1
            }
            if (this.showDev) {
              let rect =
                this.$refs[`step_image${index}`][0].getBoundingClientRect()
              let lineRect = this.$refs['line'].getBoundingClientRect()
              let width = rect.right - rect.left
              let lineWidth = lineRect.right - lineRect.left
              this.stepLeft = rect.left + (width - lineWidth) / 2
            }
            for (let i in this.steps) {
              this.steps[i].isSelected = i == index
            }
          }
        }, 2000)
      })
    },
    initAbout() {
      axios.get(this.BASE_URL + '/system/about/list', {}).then(res => {
        this.about = res.data.rows[0]
        this.about.title = this.about.title.replace('换行', '<br />')
        this.isShowAboutTitle = true
        this.startAnimation = true
        setTimeout(() => {
          this.startAnimation = false
          setTimeout(() => {
            this.isShowAboutTitle = false
          }, 1000)
        }, 3000)
      })
      this.equipments1 = []
      this.equipments2 = []
      axios.get(this.BASE_URL + '/system/equipment/list', {}).then(res => {
        for (let i of res.data.rows) {
          if (i.type == 2) {
            this.equipments2.push(i)
          } else {
            this.equipments1.push(i)
          }
        }
      })
      axios.get(this.BASE_URL + '/system/history/list', {}).then(res => {
        for (let i of res.data.rows) {
          if (i.type == 2) {
            this.years2.push(i)
          } else {
            this.years.push(i)
          }
        }
      })
    },
    initDoctor() {
      this.doctorTeamDoctors = []
      this.doctorTeamDoctors2 = []
      axios.get(this.BASE_URL + '/system/doctor/list', {}).then(res => {
        for (let i of res.data.rows) {
          if (i.certificate) {
            i.certificate = JSON.parse(i.certificate)
          }
          if (i.positionType == 1) {
            this.doctorTeamDoctors.push(i)
          } else if (i.positionType == 2) {
            this.doctorTeamDoctors2.push(i)
          }
        }
      })
    },
    initFlow() {
      axios.get(this.BASE_URL + '/system/right/list', {}).then(res => {
        this.flow = res.data.rows[0]
        this.flow.tableContent1 = JSON.parse(this.flow.tableContent1)
        this.flow.tableContent2 = JSON.parse(this.flow.tableContent2)
        this.flow.tableContent3 = JSON.parse(this.flow.tableContent3)
        this.flow.tableContent4 = JSON.parse(this.flow.tableContent4)
        this.flow.tableContent5 = JSON.parse(this.flow.tableContent5)
      })
      axios.get(this.BASE_URL + '/system/flow/list?type=2', {}).then(res => {
        this.process1 = res.data.rows
      })
      axios.get(this.BASE_URL + '/system/flow/list?type=3', {}).then(res => {
        this.process2 = res.data.rows
      })
    },
    initOperation() {
      axios.get(this.BASE_URL + '/system/operation/list', {}).then(res => {
        this.operation = res.data.rows[0]
        this.operation.tableTitle = JSON.parse(this.operation.tableTitle)
      })
      axios.get(this.BASE_URL + '/system/operationIntro/list', {}).then(res => {
        this.recommends = res.data.rows
      })
      axios.get(this.BASE_URL + '/system/comparison/list', {}).then(res => {
        for (let i of res.data.rows) {
          this.recommends2.push(JSON.parse(i.content))
        }
      })
    },
    initQuestion() {
      axios.get(this.BASE_URL + '/system/page/list', {}).then(res => {
        this.questionPage = res.data.rows[0]
      })
      axios.get(this.BASE_URL + '/system/question/list', {}).then(res => {
        this.questions = res.data.rows
        for (let i of this.questions) {
          i.content = JSON.parse(i.content)
        }
      })
      axios.get(this.BASE_URL + '/system/videos/list', {}).then(res => {
        this.questionVideos = res.data.rows
      })
    }
  }
}
</script>
<style scoped>
@import url('../assets/css/home.css');
@import url('../assets/css/bootstrap.min.css');
</style>
<style scoped>
.image_s {
  width: 220px;
  height: 220px;
}
</style>
